import { AuthError } from "firebase/auth";

export const config = {
    DefaultRoutePage: '/dashboard' 
}

/**
 * Default artist ID used when no user-artist mapping exists
 * This should match the DEFAULT_ARTIST_ID in the backend config
 */
export const DEFAULT_ARTIST_ID = '48718';

/**
 * Platform ID for primary platform mapping (Instagram)
 * Used for mapping primary DB artist IDs to secondary DB platform_artist_ids
 */
export const PRIMARY_PLATFORM_ID = 1;
// Function to get user-friendly error message from Firebase error code
export const getFirebaseErrorMessage = (error: AuthError): string => {
  switch (error.code) {
    case 'auth/requires-recent-login':
      return 'Please re-authenticate to continue.';
    case 'auth/invalid-login-credentials':
      return 'Invalid email or password. Please check your credentials and try again.';
    case 'auth/invalid-email':
      return 'The email address is not valid.';
    case 'auth/user-disabled':
      return 'This account has been disabled.';
    case 'auth/user-not-found':
      return 'No account found with this email address.';
    case 'auth/wrong-password':
      return 'Incorrect password. Please try again.';
    case 'auth/email-already-in-use':
      return 'This email is already in use by another account.';
    case 'auth/weak-password':
      return 'The password is too weak. Please use a stronger password.';
    case 'auth/operation-not-allowed':
      return 'This login method is not enabled.';
    case 'auth/account-exists-with-different-credential':
      return 'An account already exists with the same email but different sign-in credentials.';
    case 'auth/popup-closed-by-user':
      return 'The sign-in popup was closed before completing the sign in.';
    case 'auth/cancelled-popup-request':
      return 'The sign-in was cancelled.';
    case 'auth/popup-blocked':
      return 'The sign-in popup was blocked by your browser.';
    case 'auth/network-request-failed':
      return 'A network error occurred. Please check your connection and try again.';
    case 'auth/too-many-requests':
      return 'Too many unsuccessful login attempts. Please try again later.';
    case 'auth/internal-error':
      return 'An internal error occurred. Please try again later.';
    default:
      return 'An error occurred during sign in. Please try again.';
  }
};
